module.exports = __webpack_public_path__ + "media/assets/images/blog/pexels-christina-morillo-1181304-84cedab36e884646c1a4576ffd0ebf9a.jpg";